"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadBlob = void 0;
function downloadBlob(blob, fileName) {
    var fileURL = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;
    link.click();
    setTimeout(function () {
        window.URL.revokeObjectURL(fileURL);
    }, 250); // firefox requires timeout
}
exports.downloadBlob = downloadBlob;
